import React from "react";
import { Page, Card, Text, Spinner } from "@shopify/polaris";
import { APP_DISPLAY_NAME } from "../config/appBranding";
import { useAppTitleBar } from "../hooks/useAppTitleBar";
import { useEnsureInstall } from "../hooks/useEnsureInstall";
import Dashboard from "./Dashboard";

export default function Home() {
  const { installLoading, isRedirecting, isReady, installError } = useEnsureInstall();

  useAppTitleBar({ title: APP_DISPLAY_NAME });

  if (installLoading || isRedirecting) {
    return (
      <Page>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            minHeight: "min(75vh, 640px)",
            width: "100%",
            boxSizing: "border-box",
            padding: "24px",
          }}
        >
          <Spinner accessibilityLabel="Loading" size="large" />
          {isRedirecting ? (
            <Text as="p" tone="subdued">
              Redirecting to install the app…
            </Text>
          ) : null}
        </div>
      </Page>
    );
  }

  if (!isReady) {
    return (
      <Page>
        <Card>
          <Text as="p" tone="critical">
            {installError || "Checking installation…"}
          </Text>
        </Card>
      </Page>
    );
  }

  return <Dashboard />;
}
